<template>
    <div class="content">
        <div class="title">如何激活码牌</div>
        <p>App“我的”—“固定收款码”—“扫码激活设备” 扫描您的码牌，并按照提示操作即可激活。</p>
        <p>如果扫描识别失败，会提示手动输入，您可输入码牌下方的SN号即可激活。</p>
        <div class="title">如何获取音箱（语音播报设备）</div>
        <p>您可通过App“我的”—“固定收款码”—“申请官方码牌”进入设备采购专区，购买语音播报设备。</p>
        <div class="title">如何关联码牌和音箱</div>
        <p>您可通过App“我的”—“固定收款码”—“设备管理”选择已激活的码牌，进入详情选择可关联的音箱。码牌关联音箱后，该码牌的收款语音将推送到关联音箱。码牌和音箱可双向复用，即一个码牌可关联多个音箱，一个音箱也可关联多个码牌。</p>
    </div>
</template>

<script>
    export default {
        created () {
            document.title = '规则说明'
        },
    }
</script>

<style lang="scss" scoped>
.content{
    padding: 0 15px;
    color: #909399;
    font-size: 12px;
    line-height: 20px;
}
.content .title{
    font-size: 14px;
    color: #303133;
    padding: 10px 0 6px;
}
</style>